module.exports = __webpack_public_path__ + "img/def.cd3ec9fd.jpg";